module.exports = __webpack_public_path__ + "img/orders.d07981e7.svg";